import React from 'react';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { isRTL } from '../../../../helpers/formatLocale';
import { prevArrowStyle, nextArrowStyle } from '../../../../helpers/iOSthemeLayoutHelper/themeSliderHelper';
import cs from 'swiper/swiper-bundle.css';
import s from './PreviewModal.css';

function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={nextArrowStyle}
            onClick={onClick}
        >
            <svg viewBox="0 0 18 18" role="img" aria-label="Previous" focusable="false"
                style={{ height: '12px', width: '12px', display: 'block', fill: '#484848', position: 'absolute', top: '27%', right: '6px' }}>
                <path d="m4.29 1.71a1 1 0 1 1 1.42-1.41l8 8a1 1 0 0 1 0 1.41l-8 8a1 1 0 1 1 -1.42-1.41l7.29-7.29z"></path>
            </svg>

        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={prevArrowStyle}
            onClick={onClick}
        >
            <svg viewBox="0 0 18 18" role="img" aria-label="Previous" focusable="false"
                style={{ height: '12px', width: '12px', display: 'block', fill: '#484848', position: 'absolute', top: '27%', left: '5px' }}>
                <path d="m13.7 16.29a1 1 0 1 1 -1.42 1.41l-8-8a1 1 0 0 1 0-1.41l8-8a1 1 0 1 1 1.42 1.41l-7.29 7.29z"></path>
            </svg>

        </div>
    );
}
class PreviewSlider extends React.Component {

    constructor(props) {
        super(props);
        this.swiper = React.createRef();
        this.swiperPackage = require('swiper/react');
    }

    goNext = () => {
        const { current } = this.swiper;
        current?.swiper?.slideNext();
    }

    goPrev = () => {
        const { current } = this.swiper;
        current?.swiper?.slidePrev();
    }

    render() {
        const { data, intl: { locale }, isExplore } = this.props;
        const { Swiper, SwiperSlide } = this.swiperPackage;
        const params = {
            speed: 600,
            // parallax: true,
            // parallaxEl: {
            //     el: '.parallax-bg',
            //     value: '-23%'
            // },
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
        }
        return (
            <>
                {isExplore ?
                    <div className={cx(cx(s.previewSliderContainer, s.previewSliderBorder))}>  {
                        data?.map((item, index) => {
                            return (
                                <div className={s.previewNoSliderImgContainer} key={index}>
                                    <img src={item} alt={`item${index}`} />
                                </div>
                            )
                        })
                    }
                    </div> : <div className='previewSliderBox'> <div className={cx(s.previewSliderContainer, "previewSliderBtnContainer")}>
                        {data?.length > 1 ? <Swiper {...params} dir={isRTL(locale) ? 'rtl' : 'ltr'} key={isRTL(locale)} ref={this.swiper} className={cx('row homeSlickSlider')}>
                            {
                                data?.map((item, index) => {
                                    return (
                                        <SwiperSlide>
                                            <div key={index}>
                                                <div className={s.previewSliderImgContainer}>
                                                    <img src={item} alt={`item${index}`} />
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper> : <div className={s.previewSliderImgContainer}>
                            <img src={data[0]} alt={`item`} />
                        </div>}
                        <div>
                            {data?.length > 1 && <SamplePrevArrow className={cx('prevRTL')} onClick={this.goPrev} />}
                            {data?.length > 1 && <SampleNextArrow className={cx('nextRTL')} onClick={this.goNext} />}
                        </div>
                    </div>
                    </div>}
            </>
        )
    }
}

export default injectIntl(withStyles(cs, s)(PreviewSlider));